module.exports = __webpack_public_path__ + "img/card-b5.5be4336e.png";